import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.pre`
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  padding: 0 0 9px 0;
  word-break: break-word;
  white-space: pre-wrap;
  line-height: 1.2;
  font-size: ${({ $fontSize }) => $fontSize || '12px'};
`;

function stripCodeFences(str) {
  return str.replace(/^```json\s*\n?/, '').replace(/\n?```\s*$/, '');
}

function formatValue(value) {
  let str = typeof value === 'string' ? value : JSON.stringify(value);
  str = stripCodeFences(str);

  try {
    const parsed = typeof value === 'string' ? JSON.parse(str) : value;
    return JSON.stringify(parsed, null, 4);
  } catch {
    return str;
  }
}

export const FormattedJson = ({ value, fontSize }) => {
  const formatted = React.useMemo(() => formatValue(value), [value]);
  return <Wrapper $fontSize={fontSize}>{formatted}</Wrapper>;
};
